import { Deserializable } from '../interfaces';

export class GalleryUpload implements Deserializable {
  files: File;
  idTarjeta: number;
  idUsuario: number;
  idioma: string;

  constructor() {
    this.files = {} as File;
    this.idTarjeta = 0;
    this.idUsuario = 0;
    this.idioma = '';
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
